// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-help-panel__title {
  margin: 0 0 var(--dp-spacing-md);
  font-size: var(--dp-font-size-md);
  color: var(--dp-color-text);
}

.dp-help-panel__section {
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  margin-bottom: var(--dp-spacing-sm);
  overflow: hidden;
}

.dp-help-panel__section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  background: var(--dp-color-surface, #f8f9fa);
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: var(--dp-font-size-sm);
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text);
}

.dp-help-panel__section-header:hover {
  background: var(--dp-color-border);
}

.dp-help-panel__section-chevron {
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
}

.dp-help-panel__section-body {
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text);
  line-height: 1.5;
}

.dp-help-panel__section-body p {
  margin: 0 0 var(--dp-spacing-sm);
}

.dp-help-panel__section-body code {
  font-family: monospace;
  background: var(--dp-color-surface, #f8f9fa);
  padding: 1px 4px;
  border-radius: 2px;
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-primary);
}

/* Placeholder Naming examples */
.dp-help-panel__examples {
  display: flex;
  flex-direction: column;
  gap: var(--dp-spacing-xs);
  margin-bottom: var(--dp-spacing-sm);
}

.dp-help-panel__example {
  display: flex;
  align-items: center;
  gap: var(--dp-spacing-sm);
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  background: var(--dp-color-surface, #f8f9fa);
  border-radius: var(--dp-border-radius-sm);
}

.dp-help-panel__example code {
  flex-shrink: 0;
  font-weight: var(--dp-font-weight-semibold);
}

.dp-help-panel__example span {
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
}

.dp-help-panel__tip {
  font-style: italic;
  color: var(--dp-color-text-secondary);
}

/* Tag Prefixes */
.dp-help-panel__prefix-list {
  display: flex;
  flex-direction: column;
  gap: var(--dp-spacing-md);
}

.dp-help-panel__prefix {
  display: flex;
  gap: var(--dp-spacing-sm);
  align-items: flex-start;
}

.dp-help-panel__prefix p {
  margin: 2px 0 var(--dp-spacing-xs);
}

.dp-help-panel__prefix-tag {
  flex-shrink: 0;
  padding: 2px 6px;
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-bold);
  font-family: monospace;
}

.dp-help-panel__prefix-tag--if {
  background: #fff3e0;
  color: #e65100;
}

.dp-help-panel__prefix-tag--unless {
  background: #fce4ec;
  color: #c62828;
}

.dp-help-panel__prefix-tag--repeat {
  background: #e8f5e9;
  color: #2e7d32;
}

/* Type Formatting table */
.dp-help-panel__table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: var(--dp-spacing-sm);
}

.dp-help-panel__table th,
.dp-help-panel__table td {
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  text-align: left;
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
  font-size: var(--dp-font-size-xs);
}

.dp-help-panel__table th {
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: var(--dp-color-surface, #f8f9fa);
}

/* Workflow steps */
.dp-help-panel__steps {
  margin: 0;
  padding-left: var(--dp-spacing-md);
}

.dp-help-panel__steps li {
  margin-bottom: var(--dp-spacing-sm);
}

.dp-help-panel__steps li strong {
  display: block;
  color: var(--dp-color-text);
}

.dp-help-panel__steps li p {
  margin: 2px 0 0;
}

/* Placeholder text */
.dp-help-panel__placeholder-text {
  color: var(--dp-color-text-secondary);
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/HelpPanel.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,gEAAgE;EAChE,yCAAyC;EACzC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kDAAkD;EAClD,4CAA4C;EAC5C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,kDAAkD;EAClD,iCAAiC;EACjC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yCAAyC;EACzC,iCAAiC;EACjC,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;;EAEE,kDAAkD;EAClD,gBAAgB;EAChB,uEAAuE;EACvE,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,mBAAmB;AACnB;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,qCAAqC;EACrC,kBAAkB;AACpB","sourcesContent":[".dp-help-panel__title {\n  margin: 0 0 var(--dp-spacing-md);\n  font-size: var(--dp-font-size-md);\n  color: var(--dp-color-text);\n}\n\n.dp-help-panel__section {\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  margin-bottom: var(--dp-spacing-sm);\n  overflow: hidden;\n}\n\n.dp-help-panel__section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  background: var(--dp-color-surface, #f8f9fa);\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  font-size: var(--dp-font-size-sm);\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text);\n}\n\n.dp-help-panel__section-header:hover {\n  background: var(--dp-color-border);\n}\n\n.dp-help-panel__section-chevron {\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n}\n\n.dp-help-panel__section-body {\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text);\n  line-height: 1.5;\n}\n\n.dp-help-panel__section-body p {\n  margin: 0 0 var(--dp-spacing-sm);\n}\n\n.dp-help-panel__section-body code {\n  font-family: monospace;\n  background: var(--dp-color-surface, #f8f9fa);\n  padding: 1px 4px;\n  border-radius: 2px;\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-primary);\n}\n\n/* Placeholder Naming examples */\n.dp-help-panel__examples {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dp-spacing-xs);\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-help-panel__example {\n  display: flex;\n  align-items: center;\n  gap: var(--dp-spacing-sm);\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  background: var(--dp-color-surface, #f8f9fa);\n  border-radius: var(--dp-border-radius-sm);\n}\n\n.dp-help-panel__example code {\n  flex-shrink: 0;\n  font-weight: var(--dp-font-weight-semibold);\n}\n\n.dp-help-panel__example span {\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n}\n\n.dp-help-panel__tip {\n  font-style: italic;\n  color: var(--dp-color-text-secondary);\n}\n\n/* Tag Prefixes */\n.dp-help-panel__prefix-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dp-spacing-md);\n}\n\n.dp-help-panel__prefix {\n  display: flex;\n  gap: var(--dp-spacing-sm);\n  align-items: flex-start;\n}\n\n.dp-help-panel__prefix p {\n  margin: 2px 0 var(--dp-spacing-xs);\n}\n\n.dp-help-panel__prefix-tag {\n  flex-shrink: 0;\n  padding: 2px 6px;\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-bold);\n  font-family: monospace;\n}\n\n.dp-help-panel__prefix-tag--if {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.dp-help-panel__prefix-tag--unless {\n  background: #fce4ec;\n  color: #c62828;\n}\n\n.dp-help-panel__prefix-tag--repeat {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n/* Type Formatting table */\n.dp-help-panel__table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-help-panel__table th,\n.dp-help-panel__table td {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  text-align: left;\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n  font-size: var(--dp-font-size-xs);\n}\n\n.dp-help-panel__table th {\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  background: var(--dp-color-surface, #f8f9fa);\n}\n\n/* Workflow steps */\n.dp-help-panel__steps {\n  margin: 0;\n  padding-left: var(--dp-spacing-md);\n}\n\n.dp-help-panel__steps li {\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n.dp-help-panel__steps li strong {\n  display: block;\n  color: var(--dp-color-text);\n}\n\n.dp-help-panel__steps li p {\n  margin: 2px 0 0;\n}\n\n/* Placeholder text */\n.dp-help-panel__placeholder-text {\n  color: var(--dp-color-text-secondary);\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
